import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AutenticacionService } from '../modules/auth/services/autenticacion.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const autenticacionService = inject(AutenticacionService);
  const router = inject(Router);

  return next(req).pipe(
    catchError(err => {
      if (err instanceof HttpErrorResponse) {
        switch (err.status) {
          case 401:
            autenticacionService.logout();
            router.navigate(['/login']);
            break;
          case 404:
            console.error('404 Error:', err);
            break;
          case 500:
            console.error('5xx Error:', err);
            break;
          case 400:
            console.error('400 Error:', err);
            break;
          default:
            console.error('Undefined Error:', err);
            break;
        }
      } else {
        console.error('An error occurred:', err);
      }

      return throwError(() => err);
    })
  );
};
